import "./TransportationCaseStudy.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Casestudyshowcase from "./sections/Casestudyshowcase";
import Footer from "@/reusable_sections/Footer";
export default function TransportationCaseStudyPage() {
  return <div>
      <Header />
      <Hero />
      <Casestudyshowcase />
      <Footer />
    </div>;
}